<!-- Modal de Detalhes -->
<div
  *ngIf="item"
  class="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 flex items-center justify-center p-4 z-[60]"
  (click)="fechar()"
>
  <div
    class="bg-white dark:bg-gray-800 rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-start justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-br from-white via-orange-50 to-amber-50 dark:from-slate-800 dark:via-slate-800 dark:to-slate-900">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-lg flex items-center justify-center"
             [ngClass]="{
               'bg-red-100 dark:bg-red-900/30': item.tipo === 'ABONO',
               'bg-orange-100 dark:bg-orange-900/30': item.tipo === 'JUSTIFICATIVA'
             }">
          <lucide-icon
            [img]="FileIcon"
            [size]="20"
            [ngClass]="{
              'text-red-600 dark:text-red-400': item.tipo === 'ABONO',
              'text-orange-600 dark:text-orange-400': item.tipo === 'JUSTIFICATIVA'
            }">
          </lucide-icon>
        </div>
        <div>
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
            {{ item.tipo === 'ABONO' ? 'Detalhes do Abono' : 'Detalhes da Justificativa' }}
          </h3>
        </div>
      </div>
      <button
        (click)="fechar()"
        class="flex items-center justify-center w-8 h-8 ml-4 mt-1 bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
      >
        <lucide-icon [img]="XIcon" [size]="16" class="text-white"></lucide-icon>
      </button>
    </div>

    <!-- Conteúdo -->
    <div class="p-6 overflow-y-auto max-h-[calc(90vh-180px)] space-y-4">
      <!-- Tipo -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-400 mb-1">Tipo</label>
        <span
          class="inline-flex items-center px-3 py-1.5 rounded-md text-sm font-medium"
          [ngClass]="{
            'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-400': item.tipo === 'ABONO',
            'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-400': item.tipo === 'JUSTIFICATIVA'
          }">
          {{ item.tipo }}
        </span>
      </div>

      <!-- Datas -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-400 mb-1">{{ tipoFrequencia === 'AULA' ? 'Aula(s) das Faltas' : 'Data(s) das Faltas' }}</label>
        <div class="bg-gray-50 dark:bg-gray-900 rounded-md p-3">
          <div class="flex flex-wrap gap-2">
            <span
              *ngFor="let texto of obterArrayFaltasFormatadas(item.faltas)"
              class="inline-flex items-center px-2.5 py-1.5 text-sm font-medium rounded-md bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300">
              {{ texto }}
            </span>
          </div>
        </div>
      </div>

      <!-- Motivo -->
      <div *ngIf="item.motivo">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-400 mb-1">Motivo</label>
        <div class="bg-gray-50 dark:bg-gray-900 rounded-md p-3 text-sm text-gray-900 dark:text-gray-100 leading-relaxed whitespace-pre-wrap">
          {{ item.motivo.descricao }}
        </div>
      </div>

      <!-- Justificativa -->
      <div *ngIf="item.tipo === 'JUSTIFICATIVA' && item.justificativa">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-400 mb-1">Justificativa</label>
        <div class="bg-gray-50 dark:bg-gray-900 rounded-md p-3 text-sm text-gray-900 dark:text-gray-100 leading-relaxed whitespace-pre-wrap">
          {{ item.justificativa }}
        </div>
      </div>

      <!-- Observações -->
      <div *ngIf="item.observacao">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-400 mb-1">Observações</label>
        <div class="bg-gray-50 dark:bg-gray-900 rounded-md p-3 text-sm text-gray-600 dark:text-gray-400 leading-relaxed whitespace-pre-wrap">
          {{ item.observacao }}
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="p-4 border-t border-gray-200 dark:border-gray-700 flex justify-end">
      <button
        (click)="fechar()"
        class="px-6 py-2 bg-red-600 dark:bg-red-700 text-white rounded-md font-medium hover:bg-red-700 dark:hover:bg-red-600 transition-colors"
      >
        FECHAR
      </button>
    </div>
  </div>
</div>
